














































import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { FontAwesomeIcons } from '@/types';
import { CopyCabinetReferencesModel } from '@/types/models/configuration/cabinet/CopyCabinetReferencesModel';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import Vue from 'vue';
import { ObjectUtils } from '@/utils/objectUtils';

export default Vue.extend({
  name: 'CopyCabinetReferences',
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      showModal: false,
      cabinets: [] as CopyCabinetReferencesModel[],
      isLoading: false,
      searchQuery: '',
      currentPage: 1,
      tableFields: [
        { key: 'id', label: 'ID' },
        { key: 'description', label: 'Description' },
        { key: 'referenceCount', label: 'Reference Count' }
      ],
      selectedCabinet: {} as CopyCabinetReferencesModel
    };
  },
  methods: {
    async onCopyButtonClickedAsync(this: any) {
      this.showModal = true;
      if (!this.cabinets.length) {
        await this.getAllCabinetsAsync();
      }
    },
    async getAllCabinetsAsync(this: any) {
      this.isLoading = true;
      try {
        this.cabinets = await CabinetConfigurationService.getAllCabinets();
      } finally {
        this.isLoading = false;
      }
    },
    async onRefreshButtonClickedAsync(this: any) {
      await this.getAllCabinetsAsync();
    },
    async onOkClickedAsync(this: any) {
      this.$emit(
        'cabinet-selected',
        await CabinetConfigurationService.getCabinetConfigurationAsync(this.selectedCabinet.id)
      );
    },
    onHidden(this: any) {
      this.searchQuery = '';
      this.selectedCabinet = null;
    },
    onRowClicked(this: any, selectedItem: any) {
      this.selectedCabinet = selectedItem;
    }
  },
  computed: {
    okDisabled(this: any) {
      return ObjectUtils.isNullOrEmpty(this.selectedCabinet);
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner
  },
  created(this: any) {
    this.COPY_ICON = FontAwesomeIcons.Copy;
    this.COPY_BUTTON_WRAPPER_ID = 'copyCabinetReferencesButtonWrapper';
  }
});
